<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    <footerLayout style="margin-top: auto;" v-show="!$route.meta?.hideFooterLayout"/>
  </div>
</template>

<script>
import footerLayout from '@/layouts/footerLayout.vue'

export default {
  name: 'App',
  components: {
    footerLayout
  },
  data() {
    return {
      isChecked: false
    }
  },
  created() {
    // 初次使用默认设定
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'en')
    }
    if (!localStorage.getItem('extraChannel')) {
      localStorage.setItem('extraChannel', 'KKPARTNERS')
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: PingFang TC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--kk-color-text-darker);
  min-height: 100vh;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  // padding-bottom: 67px;
}
</style>
